import styled from "@emotion/styled";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

const GroupHeader = styled("div")(({ theme }: any) => ({
  top: "-8px",
  padding: "4px 10px",
  color: theme.palette.primary.main,
  fontWeight: 500,
}));

const GroupItems = styled("ul")({
  padding: 0,
});

const MonthFilter = ({
  value,
  setValue,
  placeholder,
  options,
  inputRef,
}: {
  value: { label: string; value: string; group: string };
  setValue: (value: { label: string; value: string; group: string }) => void;
  placeholder: string;
  options: { label: string; value: string; group: string }[];
  inputRef?: React.MutableRefObject<any> | null;
}) => {
  return (
    <Autocomplete
      openOnFocus
      fullWidth
      value={value}
      onChange={(e, val) => {
        setValue(val || { label: "", value: "", group: "" });
      }}
      isOptionEqualToValue={(option, val: any) => {
        return option?.value === val?.value;
      }}
      options={options}
      renderInput={(params) => (
        <TextField
          {...params}
          inputRef={inputRef}
          size="small"
          fullWidth
          placeholder={placeholder}
          value="test"
        />
      )}
      groupBy={(option) => option?.group || ""}
      renderGroup={(params) => (
        <li key={params.key}>
          {params.group && params.group !== "ALL" && (
            <GroupHeader>
              {params.group !== "ALL" ? params.group : undefined}
            </GroupHeader>
          )}
          <GroupItems>{params.children}</GroupItems>
        </li>
      )}
      renderOption={(params, option) => {
        return (
          <li
            {...params}
            key={option?.value}
            style={{
              ...params.style,
              minHeight: 30,
              padding: "10px 15px",
            }}
          >
            {option?.label || ""}
          </li>
        );
      }}
    />
  );
};

export default MonthFilter;
